import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { Navbar, Container, Nav } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { APP_ROUTES } from '../../route';
import { IMAGE_CONSTANT, TOUR_TARGET_ELEMENT } from '../../constants/app';
import { isLoggedIn } from '../../utils/helpers';
import useProfileAvatar from '../../hooks/useProfileAvatar';
import LazyImage from '../../ui-core/Image';

import '../NavFooter/style.css';

const NavFooter = ({ activeSection }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const userImage = useProfileAvatar();

  const footerNavLinks = [
    {
      title: 'Home',
      active: IMAGE_CONSTANT.HomeNavActiveIcon,
      inactive: IMAGE_CONSTANT.HomeNavInactiveIcon,
      route: APP_ROUTES.HOME,
      className: 'mobile-footer-img',
    },
    {
      title: 'Discover',
      active: IMAGE_CONSTANT.DiscoverNavActiveIcon,
      inactive: IMAGE_CONSTANT.DiscoverNavInactiveIcon,
      route: APP_ROUTES.DISCOVER,
      className: 'mobile-footer-img',
    },
    // {
    //   title: 'Explore',
    //   active: IMAGE_CONSTANT.searchActiveIcon,
    //   inactive: IMAGE_CONSTANT.searchIcon,
    //   route: APP_ROUTES.COLLECTION,
    //   className: 'mobile-footer-img',
    // },
    ...(isLoggedIn()
      ? [
          {
            title: 'Community',
            active: IMAGE_CONSTANT.CommunityActiveIcon,
            inactive: IMAGE_CONSTANT.CommunityInactiveIcon,
            route: APP_ROUTES.COMMUNITY,
            className: 'mobile-footer-img',
          },
        ]
      : []),
    {
      title: 'My Folders',
      active: IMAGE_CONSTANT.FoldersNavActiveIcon,
      inactive: IMAGE_CONSTANT.FoldersNavInactiveIcon,
      route: APP_ROUTES.FOLDERS,
      className: 'mobile-footer-img',
      dataTourId: TOUR_TARGET_ELEMENT.folders,
    },
    {
      title: 'Profile',
      inactive: userImage,
      route: APP_ROUTES.PROFILE,
      placeholderSrc: IMAGE_CONSTANT.defaultProfileIcon,
      className: 'mobile-footer-img profile-pic',
      dataTourId: TOUR_TARGET_ELEMENT.profile,
    },
  ];

  const getImageSource = (item, isActive) => {
    switch (item.title) {
      case 'Profile':
        return item.inactive;
      default:
        return isActive ? item.active : item.inactive;
    }
  };

  const isActive = (title, route) => {
    switch (title) {
      case 'Home':
        return path === APP_ROUTES.HOME;
      case 'Explore':
        return path === APP_ROUTES.COLLECTION || activeSection === 'Explore';
      case 'Community':
        return path === APP_ROUTES.COMMUNITY || path.startsWith('/community/');
      case 'Profile':
        return path === APP_ROUTES.PROFILE || path.startsWith('/profile/');
      default:
        return path === route;
    }
  };

  const handleClick = route => {
    if (route.includes('home')) {
      navigate(APP_ROUTES.HOME);
    } else {
      navigate(route);
    }
  };

  const renderNavLinks = () => {
    const navLinksOutput = footerNavLinks.map(item => (
      <Nav.Link
        key={item.title}
        className={isActive(item.title, item.route) ? 'active' : undefined}
        onClick={() => handleClick(item.route)}
        data-tour-id={item.dataTourId}
      >
        {item.title === 'Profile' ? (
          <LazyImage
            errorSrc={IMAGE_CONSTANT.defaultProfileIcon}
            placeholderSrc={IMAGE_CONSTANT.personIcon}
            src={getImageSource(item, isActive(item.title, item.route))}
            className={item.className}
          />
        ) : (
          <img
            src={getImageSource(item, isActive(item.title, item.route))}
            alt={item.title}
            className={item.className}
          />
        )}
        <span>{item.title}</span>
      </Nav.Link>
    ));
    return navLinksOutput;
  };

  return (
    <Navbar bg="" expand="sm" className="bg-white mobile-navbar">
      <Container>
        <Nav className="d-flex justify-content-around w-100">
          {renderNavLinks()}
        </Nav>
      </Container>
    </Navbar>
  );
};

NavFooter.propTypes = {
  activeSection: PropTypes.string,
};

export default NavFooter;
